import { deepLinkGenerator } from '@mssgme/shared';
import ua from './ua';

export const generateDeepLink = deepLinkGenerator(ua);
